"use client";

import { ThemeProvider as NextThemesProvider } from "next-themes";

/**
 * next-themes injects an inline <script> so dw-light/dw-dark is on <html>
 * before paint. React 19 warns when a client component re-renders that
 * script (it will not execute again). Keep the real script on the server;
 * on the client mark it application/json so React does not treat it as
 * executable. suppressHydrationWarning is already on next-themes' script.
 */
const clientThemeScriptProps = { type: "application/json" } as const;

export function ThemeProvider({ children, defaultTheme = "system", storageKey = "sablcrm-theme" }: {
    children: React.ReactNode;
    defaultTheme?: "light" | "dark" | "system";
    storageKey?: string;
}) {
    return <NextThemesProvider attribute="class" value={{ light: "dw-light", dark: "dw-dark" }} enableSystem defaultTheme={defaultTheme} storageKey={storageKey} scriptProps={typeof window === "undefined" ? undefined : clientThemeScriptProps} data-component="ThemeProvider" data-location="src/components/ui/providers/theme-provider.tsx">{children}</NextThemesProvider>;
}
